/* eslint-disable class-methods-use-this */
import {
  Module, VuexModule, getModule, Action, Mutation,
} from '@compassdigital/vuex-module-decorators';
import store from '@/store';

interface IUIModule {
  drawer: boolean,
  pane: boolean,
}

@Module({
  dynamic: true,
  namespaced: true,
  name: 'ui',
  store,
})

class UIModule extends VuexModule implements IUIModule {
  public drawer: boolean = false;

  public pane: boolean = false;

  @Mutation
  public SET_DRAWER(state: boolean) {
    this.drawer = state;
  }

  @Mutation
  public SET_PANE(state: boolean) {
    this.pane = state;
  }
}

export default getModule(UIModule);
